import React, { useState } from 'react';
import { Card, Button, Typography, Space, Alert, Row, Col } from 'antd';
import Logo from './Logo';
import { buildApiUrl } from '../utils/api';

const { Title, Text } = Typography;

const MicrosoftLogin = ({ onLogin, onVerificationRequired }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleMicrosoftLogin = async () => {
    setError('');
    setLoading(true);

    try {
      // Buscar a URL de autenticação da Microsoft
      const response = await fetch(buildApiUrl('/api/azure'));
      const data = await response.json();
      
      if (data.authUrl) {
        // Redirecionar para a página de login da Microsoft
        window.location.href = data.authUrl;
      } else {
        throw new Error('URL de autenticação não encontrada');
      }
    } catch (err) {
      setError('Erro ao iniciar autenticação Microsoft. Tente novamente.');
      setLoading(false);
    }
  };

  const MicrosoftIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" style={{ marginRight: 12 }}>
      <rect x="0" y="0" width="11" height="11" fill="#f25022"/>
      <rect x="13" y="0" width="11" height="11" fill="#7fba00"/>
      <rect x="0" y="13" width="11" height="11" fill="#00a4ef"/>
      <rect x="13" y="13" width="11" height="11" fill="#ffb900"/>
    </svg>
  );

  return (
    <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', margin: 0, padding: 0, position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}>
      <Row gutter={0} style={{ minHeight: '100vh', height: '100%', margin: 0, padding: 0, width: '100%', maxWidth: '100%' }}>
        {/* Lado Esquerdo - Formulário de Login */}
        <Col 
          xs={24} 
          md={12} 
          lg={12}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 24px',
            minHeight: '100vh'
          }}
        >
        <Card
          bordered={false}
          style={{
            width: '100%',
            maxWidth: 480,
            borderRadius: 16,
            boxShadow: '0 8px 32px rgba(45, 95, 63, 0.10)',
            border: '2px solid #ae9560'
          }}
          bodyStyle={{ padding: '48px 40px' }}
        >
          <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <Logo size="xlarge" />
              <Title level={4} style={{ margin: 0, color: '#6c757d', fontWeight: 400 }}>
                Acesse sua conta com Microsoft
              </Title>
            </Space>

            {error && (
              <Alert
                message={error}
                type="error"
                showIcon
                closable
                onClose={() => setError('')}
                style={{ textAlign: 'left' }}
              />
            )}

            <Button
              type="primary"
              size="large"
              block
              onClick={handleMicrosoftLogin}
              loading={loading}
              icon={!loading && <MicrosoftIcon />}
              style={{
                height: 64,
                fontSize: 16,
                fontWeight: 600,
                background: 'linear-gradient(135deg, #024638 0%, #4a7c59 100%)',
                border: 'none',
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {loading ? 'Autenticando...' : 'Autenticação Microsoft'}
            </Button>

            <Text type="secondary" style={{ fontSize: 14, display: 'block', marginTop: 16 }}>
              Use sua conta corporativa ou organizacional da Microsoft
            </Text>
          </Space>
        </Card>
      </Col>

      {/* Lado Direito - Área para Imagem */}
      <Col 
        xs={0} 
        md={12} 
        lg={12}
        style={{
          background: 'linear-gradient(135deg, #024638 0%, #4a7c59 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          overflow: 'hidden',
          minHeight: '100vh',
          height: '100%',
          padding: 0,
          margin: 0
        }}
      >
        <img 
          src="/images/Cultiva.jpg" 
          alt="Portal dos Franqueados"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: '35% center',
            position: 'absolute',
            inset: 0,
            display: 'block'
          }}
        />
      </Col>
    </Row>
    </div>
  );
};

export default MicrosoftLogin; 